export const courseEntitiesSelector = state => state.entities.courses;
